<ion-card class="accesscode-option p10">
  <ion-skeleton-text animated="true" style="width: 100%; height: 140px; border-radius: 5px;"></ion-skeleton-text>
  <ion-card-header>
    <ion-card-title>
      <ion-skeleton-text animated="true" style="width: 70%; height: 20px; margin-bottom: 8px;"></ion-skeleton-text>
      <ion-skeleton-text animated="true" style="width: 50%; height: 14px;"></ion-skeleton-text>
    </ion-card-title>
  </ion-card-header>
  <div class="container-button">
    <ion-skeleton-text animated="true" style="width: 100%; height: 40px; border-radius: 8px;"></ion-skeleton-text>
  </div>
</ion-card>
